// ============================================================================
// AppointmentForm Constants
// Extracted from AppointmentForm.js — pure data/config, no state dependency.
// ============================================================================

// ---------------------------------------------------------------------------
// Feature flags
// ---------------------------------------------------------------------------

// ⚠️  PRODUCTION DEPLOY REMINDER:
//     Set DEBUG_MODE to false before every production build so console logging
//     is disabled. true = developer console output, false = silent.
export const DEBUG_MODE = false;

// Set to true to show the maintenance popup and disable booking.
export const MAINTENANCE_MODE = false;

// ---------------------------------------------------------------------------
// API configuration
// ---------------------------------------------------------------------------

// Resolves to REACT_APP_API_BASE_URL when set (e.g. build-production.bat sets
// it to http://127.0.0.1:8000 for IIS), otherwise falls back to the current
// browser hostname on port 8000 so the app works on any network.
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (typeof window !== 'undefined'
    ? `http://${window.location.hostname}:8000`
    : 'http://localhost:8000');

// Express server for activity logging (/log/user-activity, /api/health).
// Uses the same host:port as the browser so it works on any network.
export const LOGGING_URL =
  typeof window !== 'undefined'
    ? `http://${window.location.hostname}:${window.location.port}`
    : 'http://localhost:3000';

// ---------------------------------------------------------------------------
// Practice identifiers
// ---------------------------------------------------------------------------

export const PRACTICE_ID_ENCRYPTED = 'v90n4IZfFGm2f9XLoBqmMg==';
export const DEFAULT_PRACTICE_ID = 200;

// ---------------------------------------------------------------------------
// Visit type definitions
// ---------------------------------------------------------------------------

export const NEW_PATIENT_VISIT_TYPE_ID = 1067;
export const EXISTING_PATIENT_VISIT_TYPE_ID = 1070;

export const NEW_PATIENT_VISIT_TYPES = [
  { id: NEW_PATIENT_VISIT_TYPE_ID, name: 'New Partnership Patient - Psych Initial Consultation', isDefault: true, duration: 40 }
];

export const EXISTING_PATIENT_VISIT_TYPES = [
  { id: EXISTING_PATIENT_VISIT_TYPE_ID, name: 'Re-Establish Care (TelePsych)', isDefault: true, duration: 40 }
];

// ---------------------------------------------------------------------------
// Clinic locations with coordinates
// Used for distance sorting and display throughout the booking flow.
// ---------------------------------------------------------------------------

export const LOCATIONS_WITH_COORDS = {
  '199': {
    id: '199',
    name: 'Redding - NAMHS',
    address: '1742 Oregon St, Redding, CA 96001',
    zipcode: '96001',
    lat: 40.5865,
    lon: -122.3917
  },
  '210': {
    id: '210',
    name: 'Eureka - NAMHS',
    address: '800 West Harris St. Suite #33, Eureka, CA 95503',
    zipcode: '95503',
    lat: 40.8021,
    lon: -124.1637
  },
  '214': {
    id: '214',
    name: 'Red Bluff - NAMHS',
    address: '420 S Main Street, Red Bluff, CA 96080',
    zipcode: '96080',
    lat: 40.1785,
    lon: -122.2358
  },
  '211': {
    id: '211',
    name: 'Fairfield - NAMHS',
    address: '500 Chadbourne Rd Suite B. Fairfield, CA 94534',
    zipcode: '94534',
    lat: 38.2494,
    lon: -122.0399
  },
  '215': {
    id: '215',
    name: 'Hollister - NAMHS',
    address: '901 Sunset Drive Unit #4. Hollister, CA 95023',
    zipcode: '95023',
    lat: 36.8525,
    lon: -121.4016
  },
  '216': {
    id: '216',
    name: 'Monterey - NAMHS',
    address: '1035 Cass St, Monterey, CA 93940',
    zipcode: '93940',
    lat: 36.6002,
    lon: -121.8947
  },
  '217': {
    id: '217',
    name: 'Salinas - NAMHS',
    address: '450 Lincoln Ave Suite 101, Salinas, CA 93901',
    zipcode: '93901',
    lat: 36.6777,
    lon: -121.6555
  },
  '212': {
    id: '212',
    name: 'Homepsych - NAMHS',
    address: 'Virtual/Online',
    zipcode: 'VIRTUAL',
    lat: null,
    lon: null,
    isVirtual: true
  }
};
